<template>
  <div class="common-radio-button-box mb-4">
    <div v-show="showTitle" class="flex items-center justify-start mb-2">
      <span class="mr-2">{{ title }}</span>
      <span :v-show="required" class="required"> * </span>
    </div>
    <div :class="{ 'is-error': error }">
      <vs-radio
        v-for="(item, index) in this.options"
        :key="index"
        v-model="inputValue"
        :vs-value="item.value"
        :color="AISEA_COLOR.BLUE"
        :vs-name="item.name"
        class="mr-4"
      >
        {{ item.label }}
      </vs-radio>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";

export default {
  name: "M.CommonRadioButton",
  mixins: [ColorMixin],
  props: {
    title: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    }

  },
  components: {
  },
  data() {
    return {
      inputValue: "",
      error: false
    }
  },
  computed: {
    validate() {
      return this.inputValue.length > 0;
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-radio-button-box {
  .required {
    color: $aisea-red;
  }

  .is-error {
    border-bottom: solid 1px $aisea-red;
  }
}
</style>